import * as React from 'react';
import { IDistrictInfrastructureCell } from '../../../../../../types/newbuildingsCompare';
import * as styles from './styles.css';
import { ActionLink, Body1 } from '@cian/ui-kit';

export interface IDistrictInfrastructureCellProps {
  cell: IDistrictInfrastructureCell;
  onMapClick?: () => void;
}

export const DistrictInfrastructureCell = ({
  cell,
  onMapClick,
}: IDistrictInfrastructureCellProps): React.JSX.Element => {
  if (!cell.data?.items?.length) {
    return (
      <div className={styles['container']}>
        <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
      </div>
    );
  }

  return (
    <div className={styles['container']}>
      {cell.data.items.map((item, index) => (
        <Body1 key={index}>{item}</Body1>
      ))}
      {onMapClick && (
        <div className={styles['map-button']}>
          <ActionLink
            data-testid="district-infrastructure-map-button"
            color="default"
            fontSize="M"
            fontWeight="bold"
            spacingSize="M"
            onClick={onMapClick}
          >
            На карте
          </ActionLink>
        </div>
      )}
    </div>
  );
};
